import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import locationService from "../service-api/locationService";

// Initial state
const initialState = {
  data: [],
  error: null,
  isLoading: true,
};

export const fetchLocations = createAsyncThunk(
  "data/fetchLocations",
  async () => {
    const response = await locationService.fetchLocations();
    return response.data;
  }
);

export const fetchActiveLocations = createAsyncThunk(
  "data/fetchActiveLocations",
  async () => {
    const response = await locationService.fetchActiveLocations();
    return response.data;
  }
);

export const addLocation = createAsyncThunk(
  "data/addLocation",
  async ({ obj }, { dispatch }) => {
    const response = await locationService.addLocation(obj);
    dispatch(fetchLocations());
    return response.data;
  }
);

export const updateLocation = createAsyncThunk(
  "data/updateLocation",
  async ({ id, obj }, { dispatch }) => {
    const response = await locationService.updateLocation(id, obj);
    dispatch(fetchLocations());
    return response.data;
  }
);

// Create slice
const locationSlice = createSlice({
  name: "locations",
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(fetchLocations.pending, (state) => {
        state.isLoading = true;
      })
      .addCase(fetchLocations.fulfilled, (state, action) => {
        state.isLoading = false;
        state.data = action.payload.value;
      })
      .addCase(fetchLocations.rejected, (state, action) => {
        state.isLoading = false;
        state.error = action.error.message;
      });

    builder
      .addCase(fetchActiveLocations.pending, (state) => {
        state.isLoading = true;
      })
      .addCase(fetchActiveLocations.fulfilled, (state, action) => {
        state.isLoading = false;
        state.data = action.payload.value;
      })
      .addCase(fetchActiveLocations.rejected, (state, action) => {
        state.isLoading = false;
        state.error = action.error.message;
      });

    builder
      .addCase(addLocation.pending, (state) => {
        state.isLoading = true;
      })
      .addCase(addLocation.fulfilled, (state, action) => {
        state.isLoading = false;
      })
      .addCase(addLocation.rejected, (state, action) => {
        state.isLoading = false;
        state.error = action.error.message;
      });

    builder
      .addCase(updateLocation.pending, (state) => {
        state.isLoading = true;
      })
      .addCase(updateLocation.fulfilled, (state, action) => {
        state.isLoading = false;
      })
      .addCase(updateLocation.rejected, (state, action) => {
        state.isLoading = false;
        state.error = action.error.message;
      });
  },
});

export default locationSlice.reducer;
